<div class="st-attachment-error-header">
     <mat-icon class="material-icons-outlined">error_outline</mat-icon>
     <div class="st-attachment-error-header-title">{{ data.title }}</div>
 </div>
<div subscriptSizing="dynamic"
     class="st-attachment-error-body">
    <div class="st-attachment-error-msg"
         *ngFor="let msg of data.messages">{{ msg }}</div>
</div>
<div class="st-attachment-error-footer">
    <button class="st-attachment-error-cancel-btn"
            mat-button
            color="secondary"
            (click)="cancel()">{{ languageSettings.PSTWebOkButtonLabel }}</button>
</div>